<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        :key="tag.path"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        {{ tag.title }}
        <span
          class="el-icon-close"
          @click.prevent.stop="closeSelectedTag(tag)"
        />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from '@/components/ScrollPane'
import path from 'path'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routers
    },
    sidebar() {
      return this.$store.state.app.sidebar
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    'sidebar.opened'() {  // 监听侧边栏状态变化
      // 当侧边栏状态改变时，延迟更新以确保DOM已更新
      this.$nextTick(() => {
        // 可以在这里添加必要的更新逻辑
      })
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
    
    // 监听浏览器刷新和关闭事件，同步删除所有缓存
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    
    // 监听侧边栏状态变化，更新菜单位置
    this.$store.watch(
      () => this.$store.state.app.sidebar.opened,
      () => {
        // 侧边栏状态变化时，如果菜单是可见的，则重新计算位置
        if (this.visible) {
          this.$nextTick(() => {
            // 延迟一点时间确保布局已更新
            setTimeout(() => {
              // 重新计算当前选中标签的位置
              if (this.selectedTag && this.$refs.tag) {
                // 这里可以添加重新定位逻辑
              }
            }, 50);
          });
        }
      }
    );
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    // 处理浏览器刷新和关闭事件
    handleBeforeUnload(event) {
      // 清除所有页面的搜索缓存
      this.clearAllPageCaches();
    },
    // 根据页面路径清除对应的搜索缓存
    clearPageCache(path) {
      // 定义页面路径与缓存键的映射关系
      const cacheKeyMap = {
        '/oms/order': 'oms_order_list_search_cache',
        '/user/userList': 'user_list_search_cache',
        '/pms/product': 'pms_product_list_search_cache',
        '/oms/apply': 'oms_apply_list_search_cache',
        '/finance/member': 'finance_member_list_search_cache',
        '/finance/withdraw': 'finance_withdraw_list_search_cache',
        '/finance/transfer': 'finance_transfer_list_search_cache',
        '/user/memberPromotion': 'member_promotion_search_cache'
      };
      
      // 查找匹配的缓存键并清除
      for (const [pagePath, cacheKey] of Object.entries(cacheKeyMap)) {
        if (path.includes(pagePath)) {
          try {
            localStorage.removeItem(cacheKey);
            console.log(`已清除页面 ${pagePath} 的搜索缓存`);
          } catch (e) {
            console.error(`清除页面 ${pagePath} 的搜索缓存失败:`, e);
          }
          break;
        }
      }
    },
    // 清除所有已知页面的搜索缓存
    clearAllPageCaches() {
      // 定义所有需要清除的缓存键
      const cacheKeys = [
        'oms_order_list_search_cache',
        'user_list_search_cache',
        'pms_product_list_search_cache',
        'oms_apply_list_search_cache',
        'finance_member_list_search_cache',
        'finance_withdraw_list_search_cache',
        'finance_transfer_list_search_cache',
        'member_promotion_search_cache'
      ];
      
      // 遍历并清除所有缓存
      cacheKeys.forEach(cacheKey => {
        try {
          localStorage.removeItem(cacheKey);
          console.log(`已清除缓存 ${cacheKey}`);
        } catch (e) {
          console.error(`清除缓存 ${cacheKey} 失败:`, e);
        }
      });
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.routes))
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      // 关闭标签前清除对应页面的搜索缓存
      this.clearPageCache(view.path);
      
      this.$store
        .dispatch('tagsView/delView', view)
        .then(({ visitedViews }) => {
          if (this.isActive(view)) {
            this.toLastView(visitedViews, view)
          }
        })
    },
    closeOthersTags() {
      // 关闭其他标签前，需要清除除选中标签外其他页面的搜索缓存
      const visitedViews = this.$store.state.tagsView.visitedViews;
      visitedViews.forEach(view => {
        // 如果不是当前选中的标签，则清除其缓存
        if (view.path !== this.selectedTag.path) {
          this.clearPageCache(view.path);
        }
      });
      
      this.$router.push(this.selectedTag)
      this.$store
        .dispatch('tagsView/delOthersViews', this.selectedTag)
        .then(() => {
          this.moveToCurrentTag()
        })
    },
    closeAllTags(view) {
      // 关闭所有标签前，需要清除所有页面的搜索缓存
      // 即使某些页面没有在tag中显示，也同步删除对应缓存
      this.clearAllPageCaches();
      
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // Redirect to home page when no tags left
        this.$router.push('/')
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const menuMinHeight = 60 // 菜单的大致高度
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetTop = this.$el.getBoundingClientRect().top // container top
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      
      // 修正：使用更精确的定位计算，考虑菜单宽度
      let left = e.clientX - offsetLeft
      
      // 确保菜单不会超出容器边界
      if (left > maxLeft) {
        this.left = maxLeft
      } else if (left < 0) {
        this.left = 0
      } else {
        this.left = left
      }

      // 修正top值计算，相对于容器顶部的位置
      let top = e.clientY - offsetTop+20
      // const maxTop = this.$el.offsetHeight - menuMinHeight // bottom boundary
      
      // if (top > maxTop) {
      //   this.top = maxTop
      // } else if (top < 0) {
      //   this.top = 0
      // } else {
        // this.top = top
      // }
      this.top=45
      
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  position: relative;
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #409eff;
        color: #fff;
        border-color: #409eff;
        &::before {
          content: '';
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/TagsView.vue